import { io } from 'socket.io-client';

let socket = null;
let socketUserId = null;

// Phones background the tab and the socket half-dies; socket.io can take ~40s
// (ping timeout) to notice. Reconnect the moment the tab is visible again so
// the next tap doesn't feel hung.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && socket && !socket.connected) {
      socket.connect();
    }
  });
}

export function getArenaSocket(userId, sleeperUsername, sleeperUserId) {
  // A different user (logout/login) must not reuse the old socket's auth.
  if (socket && socketUserId !== userId) {
    socket.disconnect();
    socket = null;
  }
  if (!socket || !socket.connected) {
    const base = process.env.REACT_APP_API_URL || '';
    socket = io(`${base}/arena`, {
      auth: { userId, sleeperUsername, sleeperUserId },
      autoConnect: true,
      reconnectionAttempts: 5,
    });
    socketUserId = userId;
  }
  return socket;
}

export function disconnectArenaSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
    socketUserId = null;
  }
}
